<div
		[ngClass]="{
    searchLoading: searchLoading,
    loggedin: isLoggedIn,
    'filter-open': showFilters
  }"
  class="row"
  id="component-products"
  >
  <loading-overlay-search></loading-overlay-search>

  <div
    [ngClass]="{ 'filter-open': showFilters }"
    class="col-3 col-md-4 col-sm-12 sidebar-left"
    >
    <filter-bar
      [(showFilters)]="showFilters"
      [featureGroups]="featureGroups"
      [loggedIn]="isLoggedIn"
    ></filter-bar>
  </div>

  <div class="col-9 col-md-12 col-sm-12 main-content">
    <div class="overview-bar">
      <div class="overview-filter-toggle">
        <button
          (click)="toggleFilterbar()"
          class="overview-filter-toggle-button theme-primary-text-color"
          type="button"
          >
          <svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
            <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
          </svg>
          <span i18n="Label shown for filters@@filterstate.title">Filters</span>
        </button>
      </div>

      <div class="overview-filter-search">
        <filter-search class="hide-lg"></filter-search>
      </div>

      @if (isLoggedIn) {
        <div class="overview-filter-scanner">
          <products-scanner></products-scanner>
        </div>
      }
    </div>

    <div [ngClass]="isLoggedIn && !forceGridView ? 'grid-3 grid-1-mobile' : 'grid-table-filter-bar'"
      class="grid-container table-filter-bar">
      <div class="grid-item">
        <h4 class="overview-title">
          @if (!productPage) {
            <span>&#95;</span>
          }

          @if (productPage) {
            <span>
              <strong>{{ productPage.totalElements }}</strong>
            </span>
          }

          <span i18n="Number of results header@@filterstate.results"
            >results</span
            >
          </h4>
        </div>
        @if (isLoggedIn && !forceGridView) {
          <div class="grid-item">
            <div class="overview-view">
              <label i18n="@@product.overview.select.view"> Choose view: </label>
              <a (click)="toggleView()" [attr.class]="getGridViewClass()">
                <svg class="icon-grid" height="30" viewBox="0 0 30 30" width="30">
                  <use xlink:href="/images/icons/svg-sprite.svg#grid"></use>
                </svg>
              </a>
              <a (click)="toggleView()" [attr.class]="getListViewClass()">
                <svg class="icon-list" height="31" viewBox="0 0 30 31" width="30">
                  <use xlink:href="/images/icons/svg-sprite.svg#list"></use>
                </svg>
              </a>
            </div>
          </div>
        }
        <div class="grid-item">
          <form class="grid-container sortOnForm align-right">
            <products-sort
              (sortChangeEvent)="loadProducts()"
              i18n-labelSortAuctionTime="@@sort.on.auctiontime"
              i18n-labelSortDescription="@@sort.on.description"
              i18n-labelSortEntryTime="@@sort.on.entrytime"
              i18n-labelSortGrower="@@sort.on.grower"
              i18n-labelSortHeight="@@sort.on.height"
              i18n-labelSortPotSize="@@sort.on.potsize"
              i18n-labelSortPrice="@@sort.on.price"
              labelSortAuctionTime="Auction time"
              labelSortDescription="Description"
              labelSortEntryTime="Entry time"
              labelSortGrower="Grower"
              labelSortHeight="Height"
              labelSortPotSize="Pot size"
              labelSortPrice="Price"
              >
            </products-sort>
          </form>
        </div>
      </div>

      <selected-filters></selected-filters>

      <div class="product-page-bar_top">
        <novi-product-pagination
          [hasExtendedSearch]="false"
          [pageData]="productPage"
          [showExtendedSearch]="showExtendedSearch()"
        ></novi-product-pagination>
      </div>

      @if (productPage) {
        @if (isListView()) {
          <div
            [attr.data-valuta]="applicationService.getUserCurrency()"
            class="overview-list"
            >
            @for (
              prod of productPage.content
              | paginate
              : {
              itemsPerPage: productPage.size,
              currentPage: productPage.number + 1,
              totalItems: productPage.totalElements
              }; track trackByFunction(i,
              prod); let i = $index) {
              <product-item-list
                #productItemListComponent
                (lazyLoad)="productItemListComponent.doLoad($event)"
						(productMatchedFragmentEvent)="
              productMatchedFragmentChangeListener($event)
            "
                (viewProductDetailClickEvent)="viewProductDetail($event, true)"
                [buttonsDisabled]="loading"
                [loggedIn]="isLoggedIn"
                [ngClass]="{ 'overview-product-stock': isStockProduct(prod) }"
                [product]="prod"
                [scrollToId]="scrollToId"
                class="overview-product"
                >
              </product-item-list>
              @if (showBannerForIndex(i)) {
                <assortment-banner
                  [bannerInterval]="bannerInterval"
                  [productIndex]="getProductIndex(i) + 1"
                ></assortment-banner>
              }
            }
          </div>
        }
        @if (!isListView()) {
          <div class="overview-grid">
            @for (
              prod of productPage.content
              | paginate
              : {
              itemsPerPage: productPage.size,
              currentPage: productPage.number + 1,
              totalItems: productPage.totalElements
              }; track trackByFunction(i,
              prod); let i = $index) {
              <product-item-grid
                #productItemGridComponent
                (lazyLoad)="productItemGridComponent.doLoad($event)"
						(productMatchedFragmentEvent)="
              productMatchedFragmentChangeListener($event)
            "
                (viewProductDetailClickEvent)="viewProductDetail($event)"
                [buttonsDisabled]="loading"
						[gridRowHasSaleProducts]="
              gridRowWithSaleProducts(prod, gridRowAmountOfColumns())
            "
						[gridRowHasStockTypes]="
              gridRowWithStockType(prod, gridRowAmountOfColumns())
            "
                [loggedIn]="isLoggedIn"
                [ngClass]="{ 'overview-product-stock': isStockProduct(prod) }"
                [product]="prod"
                [scrollToId]="scrollToId"
                [useFastCheckout]="useFastCheckout"
                [userCurrency]="applicationService.getUserCurrency()"
                class="overview-product"
                >
              </product-item-grid>
              @if (showBannerForIndex(i)) {
                <assortment-banner
                  [bannerInterval]="bannerInterval"
                  [productIndex]="getProductIndex(i) + 1"
                ></assortment-banner>
              }
            }
          </div>
        }
      }

      <div class="product-page-bar">
        <novi-product-pagination
          (triggerSearchEvent)="triggerExtendedSearch()"
          [hasExtendedSearch]="true"
          [pageData]="productPage"
          [showExtendedSearch]="showExtendedSearch()"
        ></novi-product-pagination>
      </div>

      @if (!loading) {
        <scroll-to-top
          [ngClass]="{ 'scroll-to-top--kvk': hasFooter }"
        ></scroll-to-top>
      }
    </div>
  </div>

  <add-to-shoppingcart-animation></add-to-shoppingcart-animation>
